import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const avatarVariants = tv({
  base: "flex shrink-0 items-center justify-center overflow-hidden bg-(--eci-saas-ui-avatar-bg-color)",
  variants: {
    size: {
      custom: "size-[var(--eci-saas-ui-avatar-size,40px)] text-[calc(var(--eci-saas-ui-avatar-size,40px)_/_2)]",
      // 根据design预定义的样式
      size1: "size-6  text-xs          [&_svg:not([class*='size-'])]:size-3",
      size2: "size-8  text-sm          [&_svg:not([class*='size-'])]:size-3",
      size3: "size-10 text-base        [&_svg:not([class*='size-'])]:size-3",
      size4: "size-12 text-lg          [&_svg:not([class*='size-'])]:size-4.5",
      size5: "size-16 text-2xl         [&_svg:not([class*='size-'])]:size-5",
      size6: "size-20 text-[1.75rem]   [&_svg:not([class*='size-'])]:size-6",
      size7: "size-24 text-[1.75rem]   [&_svg:not([class*='size-'])]:size-6",
      size8: "size-32 text-[2.1875rem] [&_svg:not([class*='size-'])]:size-8",
      size9: "size-40 text-6xl         [&_svg:not([class*='size-'])]:size-10"
    },
    rounded: {
      circle: "rounded-full",
      square: "rounded-(--eci-saas-ui-avatar-border-radius)",
      // 根据design预定义的样式
      "size1-square": "rounded-sm",
      "size2-square": "rounded-sm",
      "size3-square": "rounded-md",
      "size4-square": "rounded-md",
      "size5-square": "rounded-lg",
      "size6-square": "rounded-xl",
      "size7-square": "rounded-xl",
      "size8-square": "rounded-2xl",
      "size9-square": "rounded-2xl"
    }
  },
  defaultVariants: {
    size: "custom",
    rounded: "circle"
  }
}), avatarListVariants = tv({
  base: "flex",
  variants: {
    wrap: {
      default: void 0,
      wrap: "flex-wrap"
    }
  },
  defaultVariants: {
    wrap: "default"
  }
}), avatarItemVariants = tv({ base: "border-3 border-(--gray-border-2) dark:border-(--gray-text-2)" });
export {
  avatarItemVariants,
  avatarListVariants,
  avatarVariants
};
//# sourceMappingURL=index.js.map
